import { addParameterToURL } from "bm-ui-kit";
import type { PersonalLoanRequest, PersonalLoanResponseItem } from "../types";

export function convertCetelemData(
	request: PersonalLoanRequest,
	response: PersonalLoanResponseItem,
): PersonalLoanResponseItem {
	const productData = { ...response };

	if (productData.marketing?.newTargetUrl) {
		const actualGoal =
			request.loanGoals.length === 1
				? request.loanGoals[0]
				: request.loanGoals.filter((goal) => goal !== "SZABAD_FELHASZNALAS")[0];
		let cel = 10;

		switch (actualGoal) {
			case "LAKASFELUJITAS":
				cel = 1;
				break;
			case "GEPJARMU_VASARLAS":
				cel = 5;
				break;
			case "LAKASVASARLAS":
				cel = 9;
				break;
			default:
				cel = 10;
		}

		productData.marketing.newTargetUrl = addParameterToURL(productData.marketing.newTargetUrl, {
			osszeg: request.loanAmount,
			ido: request.maturityYears * 12,
			cel,
		});
	}

	return productData;
}
